import {getRequest} from "@/lib/api_client";
import {SearchResults} from "@/types/SearchResults";

interface CveProps {
  id: string;
  vendor_project: string;
  product: string;
  vulnerability_name: string;
  date_added: Date;
  short_description: string;
  required_action: string;
  due_date: Date;
  known_ransomware_campaign: string;
  notes: string;
}

export class Cve implements CveProps {
  id: string;
  vendor_project: string;
  product: string;
  vulnerability_name: string;
  date_added: Date;
  short_description: string;
  required_action: string;
  due_date: Date;
  known_ransomware_campaign: string;
  notes: string;

  constructor(cve: CveProps) {
    this.id = cve.id;
    this.vendor_project = cve.vendor_project;
    this.product = cve.product;
    this.vulnerability_name = cve.vulnerability_name;
    this.date_added = cve.date_added;
    this.short_description = cve.short_description;
    this.required_action = cve.required_action;
    this.due_date = cve.due_date;
    this.known_ransomware_campaign = cve.known_ransomware_campaign;
    this.notes = cve.notes;
  }

  static async find(query: string): Promise<Cve[]> {
    return getRequest<SearchResults>(`/api/v1/cves?query=${query}`).then(
      (response) => {
        return response.hits.map((cve) => new Cve(cve));
      },
    );
  }
}
